/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import {
  Button,
  Container as RawContainer,
  size,
  typography,
  mediaQueries,
} from '@everlywell/leaves';

export const PrimaryContainer = styled(RawContainer)`
  padding-top: ${size.lg}px;
  ${mediaQueries.forTabletVerticalUp} {
    padding-top: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;

  ${mediaQueries.forDesktopUp} {
    padding-right: ${size.lg}px;
  }
  ${mediaQueries.forBigDesktopUp} {
    padding-right: ${size.xl1}px;
  }
`;

export const Description = styled.div`
  display: none;
  ${mediaQueries.forTabletVerticalUp} {
    ${typography.bodyText}
    text-align: center;
    padding-top: ${size.md}px;
    display: block;
    max-width: 714px;
  }
`;

export const MainCTA = styled(Button)`
  margin-top: ${size.lg}px;
`;
